namespace advisorop.components.advisor {
    
    class AssignAccountHouseholdFormController {
        $router;          
        account: domains.IAccount;
       
        selInvestor: domains.IInvestor;
        selHousehold: domains.IHousehold;
        isHouseholdFormVisible: boolean = false;
        
        static $inject = ["advisorService", "accountApi"];
        constructor(private advisorService: services.AdvisorService,
            private accountApi: services.AccountApi) {
        }

        loadAccount(accountId: number) {
            this.accountApi.getById(accountId)
                .then(resp => this.account = resp.data,
                    err => toastr.error("Error " + err.status + " " + err.data));

        };
        
        showHideHouseholdForm(): void {
            if (this.isHouseholdFormVisible) {
                this.isHouseholdFormVisible = false; // hide
            }
            else {                
                this.loadInvestorHouseholds(this.selInvestor);
                this.isHouseholdFormVisible = true;
            }
        };
        
        loadInvestorHouseholds(investor: domains.IInvestor): void {

            if (!investor)
                return;


            this.advisorService.getAllHouseholdsByInvestor(investor.id)
                .success((data) => {
                    investor.households = data;
                })
                .error((data, status) => {
                    toastr.error("Household Error " + status + " " + data);
                });
        };
        
        householdCu(household: domains.IHousehold): void {
            this.selHousehold = household;
        };

        rtgCu(rtg: domains.IAccountGroup): void {
            // just refresh rtg 
            //this.loadInvestorsRTG(this.selInvestor, this.selRTG);
        };

        $onInit(): void {
        }

        $routerOnActivate(next, previous) {
            this.loadAccount(<number>next.params.accountId);
        }
    }


    class AssignAccountHouseholdForm implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;
        $canActivate;

        constructor() {
            this.controller = AssignAccountHouseholdFormController;
            this.controllerAs = "vm";
            this.bindings = {
                $router: "<"
            };
            this.templateUrl = "spa/advisor-module/views/assign-account-household-form.html";
            this.$canActivate = ["advisorService", (advisorService: services.AdvisorService) => {
                if (advisorService.isAdminModeEnabled()) {
                    toastr.info("Please exit from Admin Mode to enable Assign Household functionality");
                    return false;
                }
                return true;
            }];
        }        
    }
    angular.module(Constants.APP).component("assignAccountHouseholdForm", new AssignAccountHouseholdForm());


}